import React, { useState, useContext, createContext } from "react";
import { ThemeProvider } from "styled-components";
import { red, teal, purple, base } from "theme/themes";

export const ThemeContext = createContext();

export const useThemeContext = () => {
  return useContext(ThemeContext);
};

const themesMap = {
  red,
  teal,
  purple,
};

const ThemeContextProvider = ({ children }) => {
  const [currentTheme, setCurrentTheme] = useState("purple");
  const theme = { ...base, colors: themesMap[currentTheme] };

  return (
    <ThemeContext.Provider value={{ theme, currentTheme, setCurrentTheme }}>
      <ThemeProvider theme={theme}>{children}</ThemeProvider>
    </ThemeContext.Provider>
  );
};

export default ThemeContextProvider;
